module.exports = {"text":"מרגע הגילוי שלו באתיופיה ועד הרגע שבו אתם שותים את הראשון שלכם בבוקר","button":{"text":"פרויקט מיוחד","link":""}}


//////////////////
// WEBPACK FOOTER
// ./src/api/Welcome.json
// module id = 35
// module chunks = 0